import type { Asserts } from 'yup';

import { baseSchema } from '@/features/Input/inputBaseSchema';
import { resSchema } from '@/features/Sparten/res/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = resSchema.concat(baseSchema);

export type InputStore = Asserts<typeof inputSchema>;

export const useResInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'ResInputStore',
);
